module.exports = require("rx-lite-aggregates");


//////////////////
// WEBPACK FOOTER
// external "rx-lite-aggregates"
// module id = 10
// module chunks = 0